// COPIA DICHIARATA da src/lib/ginrummy/robot.ts @ 8a3aab5bf3a9cf073711ceeb9d50f7837089efaa (TMA#763, ginrummy-orcr-9-robot-tma), che e a sua volta la copia di TMA#746 (briscola-orcb-8-tma) @
// e823c650454b6adf11046bffc675774d6429937d: src/lib/briscola/gioco.ts, righe 25-27 (LIVELLI_ROBOT, LivelloRobot) e 55-67 (eRobotNonDisponibili). Nessun import dalla zona del gin, della briscola ne
// della scopa: se cambiano, questa copia non lo sa (la riallinea chi lo decide, non un import). Cosa e diverso dall'originale: niente, tranne i commenti, che parlano del sette e mezzo.
// Il corpo del tavolo (`creaTavoloSettemezzoBody`) sta in `gioco.ts`, accanto agli altri parametri che il sette e mezzo passa al trasporto comune: questo file non importa da `lib/gamehost/`
// (la lista esatta dei consumatori e di `tools/verify-gamehost.ts`, che non si tocca).
//
// Il «contro il robot» del sette e mezzo (contratto `fronti/kit-giochi/settemezzo.md`, I-921; decisioni 1-4 di tma-orc su I-837 estese ai giochi del kit): un tavolo casual 1v1 col campo
// `robot: { livello }` nel corpo di `POST /v1/games/settemezzo/tables`. Chi crea siede a un posto estratto dal core e l'altro posto e un robot del pool (L0-L2), col badge «bot». Il BFF
// (`limulo-app/rotte.js` di QSetteMezzo @ 5633a41c) accetta SOLO `{ livello }` con un livello noto; se il tavolo possa avere robot lo decide il core con `robotAmmessi`, non la TMA.

/** I tre livelli del robot (contratto I-833): il nome visibile e `livello.<L>` nel catalogo. */
export const LIVELLI_ROBOT = ['L0', 'L1', 'L2'] as const;
export type LivelloRobot = (typeof LIVELLI_ROBOT)[number];

/**
 * Il 503 di «Contro il robot»: il core risponde `503 no_robot_available` quando il pool del gioco non ha abbastanza account liberi, e nessun tavolo nasce. Si riconosce dallo status
 * E dal codice (ovunque stia nel corpo dell'errore: `code`, `error.code`, `message`): un ALTRO 503 (il servizio che non risponde) resta un guasto generico.
 */
export function eRobotNonDisponibili(errore: unknown): boolean {
  const e = errore as { status?: unknown; data?: unknown } | null;
  if (e === null || typeof e !== 'object' || e.status !== 503) return false;
  try {
    return JSON.stringify(e.data ?? null).includes('no_robot_available');
  } catch {
    return false;
  }
}
